import { useState } from "react";
import { RegistrationInfo } from "./registration-info";
import { useStore } from "../store";

export const registrationKey = "rinf";

const localData = localStorage.getItem(registrationKey);
export let registrationInfoStore: RegistrationInfo = localData
  ? {
      ...JSON.parse(localData),
      foodOption: "",
      extendedHours: "",
      liabilitySigned: false,
      covidGuidelinesSigned: false,
      paymentSigned: false,
      returnsSigned: false,
      photoReleaseSigned: false,
      medicalSigned: false,
      codeSigned: false,
      cancellationSigned: false,
      students: {
        "0": {
          firstName: "",
          lastName: "",
          dateOfBirth: "",
          medicalConditions: "",
          medications: "",
        },
      },
    }
  : {
      students: {
        "0": {
          firstName: "",
          lastName: "",
          dateOfBirth: "",
          medicalConditions: "",
          medications: "",
        },
      },
    };

let retries = 3;

export const useRegistration = () => {
  const [processing, setProcessing] = useState(false);
  const { state, updateState } = useStore(
    "registrationInfoStore",
    registrationInfoStore
  );
  const registrationInfo = state;

  const setRegistrationInfo = (info: Partial<RegistrationInfo>) => {
    registrationInfoStore = { ...registrationInfoStore, ...info };
    updateState(registrationInfoStore);
    localStorage.setItem(
      registrationKey,
      JSON.stringify(registrationInfoStore)
    );
  };

  const writeRegistrationInfo = () => {
    setProcessing(true);

    return fetch("https://us-central1-my-ci-crm.cloudfunctions.net/addClient", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(registrationInfoStore),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .finally(() => {
        setProcessing(false);
      });
  };

  const mapInfoToEmail = (info: RegistrationInfo) => {
    return {
      Event: info.event,
      "First name": info.firstName,
      "Last name": info.lastName,
      Email: info.email,
      Phone: info.phone,
      Students: info.students
        ? Object.values(info.students)
            .filter((student) => student.isParticipating)
            .map((student, index) => ({
              Child: index + 1,
              "First name": student.firstName,
              "Last name": student.lastName,
              "Date of birth": student.dateOfBirth,
              "Medical conditions": student.medicalConditions,
              Medications: student.medications,
            }))
        : "",
      "Food option": info.foodOption,
      "Extended hours option": info.extendedHours,
    };
  };

  const completeRegistration = () => {
    setProcessing(true);

    return fetch(
      "https://us-central1-my-ci-crm.cloudfunctions.net/completeRegistration",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(mapInfoToEmail(registrationInfoStore)),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        console.error(err);
        if (retries) {
          retries--;
          completeRegistration();
        } else {
          alert("Registration failed. Please try again.");
        }
      })
      .finally(() => {
        setProcessing(false);
      });
  };

  const sendRegistration = () => {
    setProcessing(true);

    return fetch(
      "https://us-central1-my-ci-crm.cloudfunctions.net/sendRegistration",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(registrationInfoStore),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((err) => {
        console.error(err);
        if (retries) {
          retries--;
          sendRegistration();
        } else {
          alert("Registration failed. Please try again.");
        }
      })
      .finally(() => {
        setProcessing(false);
      });
  };

  return {
    processing,
    registrationInfo,
    setRegistrationInfo,
    writeRegistrationInfo,
    completeRegistration,
    sendRegistration,
  };
};
